var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Prop, Vue } from 'vue-property-decorator';
import Tooltip from '@/components/Tooltip.vue';
import { personNameInitials } from '@/shared/utils/helpers';
import { removeHashRevokeUserEmail } from '@/shared/utils/helpers';
import IconChecked from '@/components/Icons/IconChecked.vue';
let SurveysListItem = class SurveysListItem extends Vue {
    userNameInitials(name) {
        return personNameInitials(name);
    }
    handleDate() {
        const formatDate = this.survey.created_at.slice(0, 10).split('-');
        return `${formatDate[2]}/${formatDate[1]}/${formatDate[0]}`;
    }
    handleEmail(email) {
        return removeHashRevokeUserEmail(email);
    }
    handleComment() {
        return this.survey.comment ? this.survey.comment : 'sem comentários';
    }
};
__decorate([
    Prop({ default: () => { } })
], SurveysListItem.prototype, "survey", void 0);
SurveysListItem = __decorate([
    Component({
        name: 'SurveysListItem',
        components: {
            Tooltip,
            IconChecked,
        },
    })
], SurveysListItem);
export default SurveysListItem;
